import { type Cell, type Row } from '@tanstack/react-table';
import { Fragment } from 'react';
import { cn } from '@/utils/style';

interface TableRowProps<TData> {
  row: Row<TData>;
  onRowClick?: (row: TData) => void;
  cell: (cell: Cell<TData, unknown>, index: number) => React.ReactNode;
  rowClassName?: (row: TData) => string | undefined;
  disableHover?: boolean;
}

export function TableRow<TData>(props: TableRowProps<TData>) {
  const { row, onRowClick, cell, rowClassName, disableHover } = props;
  return (
    <tr
      className={cn(
        'bg-white',
        { 'hover:bg-gray-100': onRowClick && !disableHover },
        { 'cursor-pointer': onRowClick },
        rowClassName?.(row.original)
      )}
      key={row.id}
      onClick={() => onRowClick?.(row.original)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onRowClick?.(row.original);
      }}
    >
      {row.getVisibleCells().map((cellData, index) => (
        <Fragment key={cellData.id}>{cell(cellData, index)}</Fragment>
      ))}
    </tr>
  );
}
